import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { useMentorCategory } from "./hooks"
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "50px",
    padding: "2px 4px",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    width: "100%",
  },
  iconButton: {
    marginLeft: "-40px",
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

export default function SearchBox() {
  const classes = useStyles();
  const { selectMentorCategory, industryCategoryList } = useMentorCategory()

  const handleChange = async (e) => {
    selectMentorCategory(e.target.value)
  };

  return (
    <div className={classes.root}>
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="demo-simple-select-outlined-label">Industry</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          onChange={handleChange}
          defaultValue="All"
          label="Industry"
          style={{ width: 300 }}
        >
          <MenuItem value="All">All</MenuItem>
          {industryCategoryList.data !== undefined
            ? industryCategoryList.data.map((item, key) => {
              return (
                <MenuItem
                  key={key}
                  value={item.Category}
                >
                  {item.Category}
                </MenuItem>
              );
            })
            : ""}
        </Select>
      </FormControl>
    </div>
  );
}